import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MenuItem } from '@openng/optimus-ui/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { EntityDefinition } from '../../models/entity-definition.model';
import { TableData } from '../../models/table-data.model';

@Component({
    selector: 'app-admin-base-list',
    templateUrl: './admin-base-list.component.html',
    styleUrl: './admin-base-list.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminBaseListComponent<T> extends ComponentView {

    definition: EntityDefinition<T>;
    listData: T[];
    table: TableData;

    async initParams(): Promise<boolean> {
        await this.initAdditionalData();
        await this.initData();
        this.updateNavigation(null, [
            { label: this.app.t("general.administration"), routerLink: ["/base2", "admin"] },
            this.getBreadcrumbItem()
        ]);

        return true;
    }

    async initAdditionalData(): Promise<void> {
    }

    async initData(): Promise<void> {
        this.listData = await this.app.loadDataHandler(async () => this.getData(), this);
        this.table = this.getTable();        
    }

    async getData(): Promise<T[]> {
        return this.definition.restList();
    }

    getTable(): TableData {
        return null;
    }
    
    getBreadcrumbItem(): MenuItem {
        return { label: this.definition.getNamePlural(), routerLink: this.definition.adminListUrl };
    }
}
